import { Grid, Typography } from '@material-ui/core'
import React from 'react'

export default function CustomViewForm({ data }) {
  console.log('data ', data)
  return (
    <Grid container>
      <Grid item lg={12} container spacing={3}>
        {data?.length &&
          data?.map(({ label, type, data, value, extraValues, grid, style, onClick }, index) => (
            <Grid item lg={grid ? grid : 4} key={index}>
              <div style={{ display: 'flex', flexDirection: 'column', padding: '10px' }}>
                <Typography style={{ fontSize: '16px', fontWeight: 600 }}>{label}</Typography>

                {(type === 'ARRAY' || type === 'Array') &&
                  data &&
                  data.map((val) => {
                    return (
                      <Typography style={{ fontSize: '14px', fontWeight: 400, ...val.style }}>
                        {value && val[value]}
                        {extraValues && extraValues.map((v) => ` / ${val[v]}`)}
                        {!value && val}
                      </Typography>
                    )
                  })}

                {!type && (
                  <Typography style={{ fontSize: '14px', fontWeight: 400, ...style }} onClick={onClick}>
                    {data}
                  </Typography>
                )}
              </div>
            </Grid>
          ))}
      </Grid>
    </Grid>
  )
}
